import EditProfile from "pages/Views/Profile/EditProfile";
import Agreement from "../pages/Views/Agreement";
import Dashboard from "../pages/Views/dashboard";
import MyProfile from "../pages/Views/profile";
import ViewProfile from "../pages/Views/Profile/ViewProfile";
import ProjectManagement from "../pages/Views/ProjectMagement/ProjectManagementList";
import Login from "pages/Auth/login";
import SignUp from "pages/Auth/sign-up";
import ForgotPassword from "pages/Password/ForgotPassword";
import NotFound from "pages/NotFound";
import Forbidden from "pages/Forbidden";
import CreateNewProject from "pages/Views/ProjectMagement/CreateNewProject";
import CreateProject from "pages/Views/ProjectMagement/CreateProjectForms/CreateProject";
import ContactReview from "pages/Views/ContactReview";
import EditProject from "pages/Views/ProjectMagement/CreateProjectForms/EditProject";
import EditContract from "pages/Views/ContractGenerator/CreateContractForm/EditContract";
import CreateContract from "pages/Views/ContractGenerator/CreateContractForm/CreateContract";
import Document from "pages/Views/commonComponents/Document/Document";
import ContractListing from "pages/Views/commonComponents/ContractListing";

export const PublicRoutes = [
  {
    path: "/",
    name: "Login",
    element: <Login />,
  },
  {
    path: "/login",
    name: "Login",
    element: <Login />,
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    element: <SignUp />,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    element: <ForgotPassword />,
  },
  {
    path: "/404",
    name: "404",
    element: <NotFound />,
  },
  {
    path: "/403",
    name: "403",
    element: <Forbidden />,
  },
];

export const PrivateRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    element: <Dashboard />,
  },
  {
    path: "/project-management",
    name: "Dashboard",
    element: <ProjectManagement />,
  },
  {
    path: "/agreement",
    name: "Reports",
    element: <Agreement />,
  },
  {
    path: "/profile",
    name: "Profile",
    element: <ViewProfile />,
  },
  {
    path: "/profile/edit",
    name: "Edit Profile",
    element: <EditProfile />,
  },

  {
    path: "/create-project",
    name: "Crate New Project",
    element: <CreateProject />,
  },
  {
    path: "/edit-project/:id",
    name: "Edit Project",
    element: <EditProject />,
  },
  {
    path: "/contract-generator",
    name: "Contract Generator",
    element: <CreateContract />,
  },
  {
    path: "/contract-generator/:id",
    name: "Contract Generator",
    element: <EditContract />,
  },
  // {
  //   path: "/document/:id",
  //   name: "Document",
  //   element: <Document />,
  // },
  {
    path: "/contracts",
    name: "Contract Listing",
    element: <ContractListing />,
  },
  {
    path: "/contract-review",
    name: "Contract Review",
    element: <ContactReview />,
  },
];
